export const OpenWeatherApiKey = import.meta.env.VITE_OPEN_WEATHER

export const MMLApiKey = import.meta.env.VITE_MML;

export const DefaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE || 'fi';

export const BasePath = import.meta.env.VITE_BASE_PATH || "/";
